export const sports: TableModule = {
    name: "sports",
    route: "spa.basicData.sports",
    defaultOrder: {
        column: "id",
        direction: "asc"
    },
    columns: [
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true,
        },
        {
            name: "status",
            mobile: true,
            width: "w-[75px]"
        }
    ],
    filters: [],
    quickFilters: [],
    tools: []
}